/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import PropTypes from "prop-types";

import NewFaqs from "./NewFaqs";

const propTypes = {
  faqList: PropTypes.array.isRequired
};

const FaqsContainer = ({faqList}) => {
  return (
    <NewFaqs faqList={faqList} />
  );
};
FaqsContainer.propTypes = propTypes;

export default FaqsContainer;
